import { observer } from 'mobx-react-lite'
import { Outlet } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { useEntitiesContext } from 'entities/EntitiesExport'

const CallPopUpLayout = observer(() => {
  const {
    callStore,
    featureFlagsStore,
    userSettingsStore,
    inboxesStore,
    organizationStore,
    websocket,
    authStore,
  } = useEntitiesContext()
  const { refresh } = authStore
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    refresh({ enableLoader: false })
      .then(async (data) => {
        if (data?.is_login) {
          await Promise.all([
            organizationStore.init(),
            userSettingsStore.fetchUsersSettings(),
            featureFlagsStore.fetchFeatureFlags(),
            inboxesStore.fetchInboxes(),
          ])

          if (userSettingsStore.isSalesmsgDesignV2) {
            await callStore.initDevice()
          }

          websocket.connect()
        }

        return data
      })
      .then(() => {
        setLoading(false)
      })
  }, [])

  if (loading) return null

  return <Outlet />
})

export default CallPopUpLayout
